<app-modal
  #modal
  [modalConfig]="{
    titleText: 'Create LMS Course',
    options: { size: 'm' },
    headerClass: ['modal-header', 'bg-primary', 'text-white', 'border-0'],
    bodyClass: ['p-0'],
    customFooter: true
  }"
  (isClosing)="resetModal()"
  (isDismissing)="resetModal()">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="modal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="w-100" style="background-color: #fff; min-height: 500px">
    <div class="container">
      <div class="mb-3" *ngIf="!courseFile">
        <label class="form-label">Upload Course SCORM File</label>
        <app-file-upload
          #uploadComponent
          [uploadType]="uploadType"
          [style]="uploadStyle"
          [multiple]="false"
          (outputFiles)="updateCourseFile($event)" />
      </div>
      <div class="mb-3" *ngIf="courseFile">
        <label class="form-label">Send course file to SCORM Cloud</label>
        <div>
          <span class="fs-6">{{ courseFileShort }}</span>
        </div>
        <button
          (click)="createCourse()"
          aria-label="Create Course in SCORM Cloud"
          class="btn btn-primary"
          type="button"
          [autoClose]="'outside'"
          ngbTooltip="Create Course"
          [disabled]="isLoading">
          Send to SCORM Cloud
        </button>
        <button
          (click)="deleteCourseFile()"
          aria-label="Delete course file"
          class="btn btn-delete"
          type="button"
          [autoClose]="'outside'"
          ngbTooltip="Delete Course File">
          <i class="bi bi-trash"></i>
        </button>
      </div>
      <ng-container *ngIf="errorMessage">
        <div class="p-3">
          <div class="alert alert-danger">
            {{ errorMessage }}
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="isLoading">
      <div class="w-100" style="background-color: #fff; height: 400px">
        <app-loader></app-loader>
      </div>
    </ng-container>
  </div>
  <div footerContent>
    <button
      type="button"
      class="btn btn-md btn-primary"
      (click)="modal.close(); resetModal()">
      Done
    </button>
  </div>
</app-modal>
